module.exports = __webpack_public_path__ + "static/nat-2-84bf59cb21308c2b1dd07401a6e49c42.jpg";